module.exports = __webpack_public_path__ + "static/media/iphone.a0185112.png";